import * as React from "react"

const SvgWallet = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.075 15.504q-.425.425-1.075.425t-1.075-.425-.425-1.075.425-1.075T16 12.929t1.075.425q.425.424.425 1.075 0 .65-.425 1.075" />
    <path
      fillRule="evenodd"
      d="M3 7.429q0-1.65 1.175-2.825T7 3.429h11a1 1 0 1 1 0 2H7q-.824 0-1.412.587A1.93 1.93 0 0 0 5 7.429h14q.824 0 1.413.587.587.588.587 1.413v10q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.587H5q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19.428zm2 2.003v9.993l.002.002.001.002h13.994l.001-.002.002-.002V9.432l-.002-.002-.001-.001H5.003l-.001.001z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgWallet
